// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamic-table__clamp-wrapper{display:block;width:100%}.dynamic-table__clamp-wrapper>div{display:block;width:100%}.dynamic-table__clamp{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:var(--dynamic-table-clamp-lines, 4);line-clamp:var(--dynamic-table-clamp-lines, 4);overflow:hidden;white-space:normal;overflow-wrap:break-word}", ""]);
// Exports
module.exports = exports;
